import { render, staticRenderFns } from "./DevBpbjInfoList.vue?vue&type=template&id=8b3aaa06&scoped=true&"
import script from "./DevBpbjInfoList.vue?vue&type=script&lang=js&"
export * from "./DevBpbjInfoList.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjInfoList.vue?vue&type=style&index=0&id=8b3aaa06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3aaa06",
  null
  
)

export default component.exports